import { render } from "./TarifsSection.vue?vue&type=template&id=2abc6bd0&scoped=true"
const script = {}

import "./TarifsSection.vue?vue&type=style&index=0&id=2abc6bd0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2abc6bd0"]])

export default __exports__